module.exports = __webpack_public_path__ + "static/media/logo_ios.18d98cff.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/logo_ios.png
// module id = 403
// module chunks = 1